import { memo } from 'react';

import { DesignAvatar } from '@components/design-avatar';
import { useScopedTranslate } from '@locale/translate';

import { TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

type ActionType = 'ask_ai_agent';

export const Node = memo((node: TravellerJourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);

  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        isColorful
        node={node}
        label={node.data.values?.name ?? t('title')}
        descriptionText={node.data.description}
        icon={<DesignAvatar src={node.data.values?.picture} />}
      >
        <NodeActions node={node} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    title: 'Ask AI Agent',
  },
};
